// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1VxrT","footer":"ReportModalFilter_footer__2gBrv"};